import type { BreadcrumbItem } from '@/components/ui/Breadcrumbs/components/Breadcrumbs.shared';
import type { ServicePricesSearchInitialData } from '@/lib/service/servicePricesSearchInitialData';

/**
 * Known keys passed from route orchestrators into {@link CMSRenderer}.
 * Additional page-specific keys remain allowed via the index signature.
 */
export type CMSRendererExtraData = Record<string, unknown> & {
  locale?: string;
  /** CMS catch-all page slug (e.g. `service`) — used by {@link CmsBreadcrumbBlock}. */
  cmsPageSlug?: string;
  /** CMS page title for the current crumb label. */
  cmsPageTitle?: string | null;
  /** Pre-built trail (PLPs); overrides slug/title generation when set. */
  breadcrumbs?: BreadcrumbItem[];
  servicePrices?: ServicePricesSearchInitialData;
  /** Mirrors `FEATURE_SERVICE_REQUEST` for CMS service placeholders (e.g. ServiceStatus). */
  serviceRequestEnabled?: boolean;
  /** Market ECS availability for CMS service placeholders (e.g. ServiceRequest send channel). */
  ecsAvailable?: boolean;
};

export function getCmsLocale(extraData?: CMSRendererExtraData): string | undefined {
  return typeof extraData?.locale === 'string' ? extraData.locale : undefined;
}

export function getPlaceholderServiceRoutingProps(
  extraData?: CMSRendererExtraData | Record<string, unknown>
) {
  const record = extraData as CMSRendererExtraData | undefined;
  return {
    locale: getCmsLocale(record),
    serviceRequestEnabled: record?.serviceRequestEnabled === true,
    ecsAvailable: record?.ecsAvailable === true,
  };
}

export function getCmsExtraDataRecord(
  extraData?: CMSRendererExtraData
): CMSRendererExtraData | undefined {
  return extraData;
}
